import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          <div className="col-span-2 md:col-span-1">
            <span className="text-xl font-heading font-bold text-background-50 mb-4 block">布丁漫画</span>
            <p className="text-sm text-background-400 leading-relaxed">
              海量正版韩国漫画在线阅读平台，让每一位读者免费享受优质韩漫。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/category/romance" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">漫画分类</Link>
              <Link to="/article/goddess-of-destiny" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">热门推荐</Link>
              <Link to="/about" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/romance" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">恋爱漫画</Link>
              <Link to="/category/action" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">动作漫画</Link>
              <Link to="/category/fantasy" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">奇幻漫画</Link>
              <Link to="/category/drama" className="text-sm text-background-400 hover:text-background-200 transition-colors whitespace-nowrap">剧情漫画</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2 text-sm text-background-400">
              <span>contact@puddingcomic.com</span>
              <span>400-888-6666</span>
              <span>北京市朝阳区望京SOHO</span>
            </div>
          </div>
        </div>

        <div className="border-t border-background-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2024-2026 布丁漫画 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg" />
            </a>
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg" />
            </a>
            <a href="#" className="text-background-500 hover:text-background-300 transition-colors" aria-label="邮箱">
              <i className="ri-mail-line text-lg" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}